const icons: Record<
  string,
  ({
    width,
    height,
    color,
  }: {
    width?: number;
    height?: number;
    color?: string;
  }) => JSX.Element
> = {
  close: ({ color = 'var(--color-neutral)' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  folder: ({ color = 'var(--color-neutral-550)' }) => (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.08341 7.99992H4.90172C5.47272 7.99992 5.99472 8.32253 6.25008 8.83325C6.50544 9.34397 7.02744 9.66659 7.59844 9.66659H12.4017C12.9727 9.66659 13.4947 9.34397 13.7501 8.83325C14.0054 8.32253 14.5274 7.99992 15.0984 7.99992H17.9167M7.47222 1.33325H12.5279C13.4253 1.33325 13.874 1.33325 14.2702 1.46989C14.6205 1.59072 14.9396 1.78792 15.2043 2.04721C15.5037 2.34042 15.7043 2.74175 16.1057 3.5444L17.9111 7.15534C18.0686 7.47032 18.1474 7.62782 18.2029 7.79287C18.2522 7.93946 18.2878 8.09031 18.3093 8.24347C18.3334 8.41594 18.3334 8.59202 18.3334 8.94419V10.6666C18.3334 12.0667 18.3334 12.7668 18.0609 13.3016C17.8212 13.772 17.4388 14.1544 16.9684 14.3941C16.4336 14.6666 15.7335 14.6666 14.3334 14.6666H5.66675C4.26662 14.6666 3.56655 14.6666 3.03177 14.3941C2.56137 14.1544 2.17892 13.772 1.93923 13.3016C1.66675 12.7668 1.66675 12.0667 1.66675 10.6666V8.94419C1.66675 8.59202 1.66675 8.41594 1.69089 8.24347C1.71234 8.09031 1.74795 7.93946 1.79726 7.79287C1.8528 7.62782 1.93155 7.47032 2.08904 7.15534L3.89451 3.5444C4.29583 2.74174 4.4965 2.34042 4.79587 2.04721C5.06061 1.78792 5.37968 1.59072 5.72999 1.46989C6.12613 1.33325 6.57482 1.33325 7.47222 1.33325Z"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  image: ({ color = 'var(--color-neutral)' }) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.27209 20.7279L10.8686 14.1314C11.2646 13.7354 11.4627 13.5373 11.691 13.4632C11.8918 13.3979 12.1082 13.3979 12.309 13.4632C12.5373 13.5373 12.7354 13.7354 13.1314 14.1314L19.6839 20.6839M14 15L16.8686 12.1314C17.2646 11.7354 17.4627 11.5373 17.691 11.4632C17.8918 11.3979 18.1082 11.3979 18.309 11.4632C18.5373 11.5373 18.7354 11.7354 19.1314 12.1314L22 15M10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9ZM6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  message: ({ color = 'white' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M6.96936 11.2288C6.90721 10.8282 6.87496 10.4179 6.87496 10C6.87496 5.58172 10.4802 2 14.9276 2C19.3749 2 22.9802 5.58172 22.9802 10C22.9802 10.9981 22.7963 11.9535 22.4602 12.8345C22.3904 13.0175 22.3554 13.109 22.3396 13.1804C22.3239 13.2512 22.3178 13.301 22.3161 13.3735C22.3144 13.4466 22.3243 13.5272 22.3442 13.6883L22.7467 16.9585C22.7903 17.3125 22.8121 17.4895 22.7532 17.6182C22.7016 17.731 22.61 17.8205 22.4961 17.8695C22.3661 17.9254 22.1896 17.8995 21.8367 17.8478L18.6515 17.3809C18.4851 17.3565 18.402 17.3443 18.3262 17.3448C18.2513 17.3452 18.1995 17.3507 18.1261 17.3661C18.052 17.3817 17.9573 17.4172 17.768 17.4881C16.8847 17.819 15.9274 18 14.9276 18C14.5094 18 14.0987 17.9683 13.6977 17.9073M8.50658 22C11.4715 22 13.875 19.5376 13.875 16.5C13.875 13.4624 11.4715 11 8.50658 11C5.54168 11 3.13816 13.4624 3.13816 16.5C3.13816 17.1106 3.23528 17.6979 3.41455 18.2467C3.49033 18.4787 3.52822 18.5947 3.54066 18.6739C3.55364 18.7567 3.55591 18.8031 3.55108 18.8867C3.54645 18.9668 3.52641 19.0573 3.48634 19.2383L2.875 22L5.8698 21.591C6.03327 21.5687 6.115 21.5575 6.18637 21.558C6.26152 21.5585 6.30141 21.5626 6.37511 21.5773C6.4451 21.5912 6.54916 21.6279 6.75727 21.7014C7.30559 21.8949 7.89411 22 8.50658 22Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pdf: ({ width = 24, height = 24, color = 'var(--color-neutral)' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.26946V6.4C14 6.96005 14 7.24008 14.109 7.45399C14.2049 7.64215 14.3578 7.79513 14.546 7.891C14.7599 8 15.0399 8 15.6 8H19.7305M14 11H8M16 15H8M10 7H8M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  zip: ({ width = 24, height = 24, color = 'var(--color-neutral)' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12v-1M10 18v-2M10 7V6M14 2v4a2 2 0 0 0 2 2h4M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10"
        cy="20"
        r="2"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sendMessage: ({ color = 'currentColor' }) => (
    <svg
      className="w-6 h-6 rotate-90"
      fill={color}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
    </svg>
  ),
  line: ({ width = 24, height = 24, color = 'currentColor' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0"
    >
      <path
        d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.63-.285-.63-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.349 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.349 0-.63-.285-.63-.629V8.108c0-.345.281-.63.63-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.346 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.281.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.039 1.085l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"
        fill={color}
      />
    </svg>
  ),
};

export default icons;
